import React, {Component} from "react";
import {Button, Col, Form, Modal, Row, Table} from "react-bootstrap";
import {getMissingPrivileges, insertSinglePrivilege} from "../../../services/RequestService";
import {alertActions} from "../../../store/actions/AlertActions";
import {connect} from "react-redux";

class ModalInsertSinglePrivilege extends Component {
  constructor(props) {
    super(props);
    this.state = {
      missingPrivileges: [],
      privilege: null,
    };
  }

  componentDidMount = () => {
    getMissingPrivileges({ cellId: this.props.cellId }).then((res) => {
      if (res.ok) {
        this.setState({
          missingPrivileges: res.data.filter(
            (item) => item.privilege.name !== "configuracoes/celulas"
          ),
        });
      }
    });
  };

  handleInputChange = (e) => {
    const selected = this.state.missingPrivileges.find(
      (el) => el.privilege.name === e.target.value
    );
    if (selected) {
      this.setState({
        privilege: {
          name: selected.privilege.name,
          privilegeId: selected.privilege.id,
          insert: selected.insert,
          read: selected.read,
          update: selected.update,
          delete: selected.delete,
        },
      });
    }
  };

  submit = () => {
    const { privilege } = this.state;
    insertSinglePrivilege({
      privilegeId: privilege.privilegeId,
      cellId: this.props.cellId,
      insert: privilege.insert !== null ? privilege.insert : false,
      read: privilege.read !== null ? privilege.read : false,
      update: privilege.update !== null ? privilege.update : false,
      delete: privilege.delete !== null ? privilege.delete : false,
    }).then((res) => {
      if (res.ok) {
        this.props.onAddAlert("Privilégio adicionado com sucesso", "success", false);
        this.props.onHide(true);
      } else {
        this.props.onAddAlert("Houve um problema ao tentar adicionar privilégio.", "danger", false);
      }
    });
  };

  render() {
    const { show, onHide } = this.props;
    const { missingPrivileges, privilege } = this.state;

    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: '16px' }}>Adicionar um novo privilégio</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col>
              <Form.Group controlId="selectPrivilege">
                <Form.Label>Privilégios faltantes</Form.Label>
                <Form.Control
                  as="select"
                  size="sm"
                  value={privilege?.name || ''}
                  onChange={this.handleInputChange}
                >
                  <option value="" />
                  {missingPrivileges?.map((value) => (
                    <option key={value.privilege.id} value={value.privilege.name}>
                      {value.privilege.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>

          <Table
            striped
            bordered
            hover
            responsive
            className="table cell-table-responsible bms-color-text"
          >
            <thead className="text-center">
            <tr>
              <th>Nome</th>
              <th>Criar</th>
              <th>Ver</th>
              <th>Editar</th>
              <th>Excluir</th>
            </tr>
            </thead>
            <tbody className="text-center">
            <tr>
              <td>{privilege?.name}</td>
              {['insert', 'read', 'update', 'delete'].map((field) => (
                <td key={field}>
                  {privilege && (
                    <Form.Check
                      checked={!!privilege[field]}
                      onChange={() =>
                        this.setState({ privilege: { ...privilege, [field]: !privilege[field] } })
                      }
                      disabled={privilege[field] === null}
                    />
                  )}
                </td>
              ))}
            </tr>
            </tbody>
          </Table>

          <Button
            variant="primary"
            className="w-100 modal-user-button-without-rounded"
            onClick={this.submit}
            disabled={!privilege}
          >
            Adicionar
          </Button>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  onAddAlert: (text, alertType, alertPriority) =>
    dispatch(alertActions.addAlert(text, alertType, alertPriority)),
});

export default connect(null, mapDispatchToProps)(ModalInsertSinglePrivilege);
